import Routers from 'router'
import { Toaster, resolveValue, toast } from 'react-hot-toast'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FeatureFlagsProvider } from 'hooks/useFeatureFlag'

const TOAST_ICONS: Record<string, { bg: string; icon: string; label: string }> = {
	success: { bg: 'bg-emerald-500/20 border-emerald-500/30', icon: '✓', label: 'text-emerald-400' },
	error: { bg: 'bg-red-500/20 border-red-500/30', icon: '✕', label: 'text-red-400' },
	// A plain `toast()` is the neutral notice: the success fallback would show a tick.
	blank: { bg: 'bg-blue-500/20 border-blue-500/30', icon: 'i', label: 'text-blue-400' },
	loading: { bg: 'bg-blue-500/20 border-blue-500/30', icon: '…', label: 'text-blue-400' },
}

function App() {
	return (
		<div className="App">
			<FeatureFlagsProvider>
				<Routers />
				<Toaster
					position="bottom-right"
					toastOptions={{
						duration: 6000,
					}}
				>
					{(t: any) => {
						const config = TOAST_ICONS[t.type] ?? TOAST_ICONS.success
						return (
							<div
								className={clsx(
									'flex items-start gap-3 bg-primary-surface/[0.85] backdrop-blur-xl border border-translucent-plus-border rounded-xl px-4 py-3 shadow-[0_4px_24px_rgba(0,0,0,0.4)] max-w-[340px] w-full transition-all duration-300',
									{ 'opacity-0 scale-95': !t.visible, 'opacity-100 scale-100': t.visible }
								)}
							>
								{/* Icon badge */}
								<div
									className={clsx(
										'flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center border text-sm font-bold mt-0.5',
										config.bg,
										config.label
									)}
								>
									{t.type === 'loading' ? (
										<FontAwesomeIcon icon={['fas', 'spinner']} spin className="text-xs" />
									) : (
										<span>{config.icon}</span>
									)}
								</div>

								{/* Message */}
								<div className="flex-1 min-w-0 pt-0.5">
									<p className="text-sm font-medium text-primary-text leading-snug break-words">
										{resolveValue(t.message, t)}
									</p>
								</div>

								{/* Dismiss button */}
								<button
									type="button"
									onClick={() => toast.dismiss(t.id)}
									className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full text-secondary-text hover:text-primary-text hover:bg-white/10 transition-colors mt-0.5"
									aria-label="Dismiss"
								>
									<span className="text-xs leading-none">✕</span>
								</button>
							</div>
						)
					}}
				</Toaster>
			</FeatureFlagsProvider>
		</div>
	)
}

export default App
